import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SessionUser {
  id: string;
  name: string;
  email: string;
  role: string;
  status: string;
  twoFactorEnabled: boolean;
  acceptedTermsAt: string | null;
  id_company: string;
  [key: string]: unknown;
}

interface SessionState {
  logged: boolean;
  user: SessionUser | null;
}

const initialState: SessionState = {
  logged: false,
  user: null,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<SessionUser>) => {
      state.logged = true;
      state.user = action.payload;
    },
    logout: state => {
      state.logged = false;
      state.user = null;
    },
    updateUser: (state, action: PayloadAction<Partial<SessionUser>>) => {
      if (state.user) {
        Object.assign(state.user, action.payload);
      }
    },
  },
});

export const { login, logout, updateUser } = sessionSlice.actions;
export default sessionSlice.reducer;
